import styled from "@emotion/styled";
import { FC } from "react";

export const Toggle: FC<{ onClick: () => void; enabled: boolean }> = ({
  onClick,
  enabled,
}) => {
  return (
    <ToggleContainer>
      <ToggleButton onClick={onClick} enabled={enabled} />
    </ToggleContainer>
  );
};

const ToggleContainer = styled.div`
  font-weight: 500;
  font-size: 1rem;
  text-align: left;
  height: 100%;
  flex: 1;
`;

const ToggleButton = styled.div<{ enabled: boolean }>`
  position: relative;
  height: 24px;
  width: 44px;
  border-radius: 40px;
  margin-left: auto;
  margin-right: 0;
  cursor: pointer;
  background: ${(p) => (p.enabled ? "#6aaa64" : "#787c7e")};
  transition: all 150ms ease;

  &:after {
    content: "";
    border-radius: 100%;
    background: #ffffff;
    height: 18px;
    width: 18px;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: all 150ms ease;

    transform: translateX(${(p) => (p.enabled ? "20px" : "0px")});
  }
`;
